// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: dlPCkyBhzqm_
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import SearchRectangle from "../../SearchRectangle"; // plasmic-import: 8zoHL39XdeHp/component
import MenuSelectStack from "../../MenuSelectStack"; // plasmic-import: 5NpjpkJRYPLT/component
import LoginInput from "../../LoginInput"; // plasmic-import: IUjDjOBqC9S0/component
import MilestoneEntry from "../../MilestoneEntry"; // plasmic-import: h4sfzrx-5tAI/component
import AdvancedOptionsComponent from "../../AdvancedOptionsComponent"; // plasmic-import: 6rSjFDYDzjHH/component
import Switch from "../../Switch"; // plasmic-import: g3F1mEXIUWbM/component
import AutomationSelect from "../../AutomationSelect"; // plasmic-import: Py2v0fi9A7zB/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicEscrowSubmission.module.css"; // plasmic-import: dlPCkyBhzqm_/css

createPlasmicElementProxy;

export const PlasmicEscrowSubmission__VariantProps = new Array();

export const PlasmicEscrowSubmission__ArgProps = new Array(
  "contractUploadText",
  "companySelected",
  "emailSelected"
);

const $$ = {};

function PlasmicEscrowSubmission__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "achSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "cardSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "cardSurchargeSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "paymentReminderSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "paymentReminderSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__tDiXt)}>
            <div className={classNames(projectcss.all, sty.freeBox__iGwen)}>
              <div
                data-plasmic-name={"sheet2"}
                data-plasmic-override={overrides.sheet2}
                className={classNames(projectcss.all, sty.sheet2)}
              >
                <Stack__
                  as={"div"}
                  data-plasmic-name={"figmaPaste"}
                  data-plasmic-override={overrides.figmaPaste}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.figmaPaste)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox___0D2UO)}
                  >
                    <div
                      data-plasmic-name={"title4"}
                      data-plasmic-override={overrides.title4}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title4
                      )}
                    >
                      {"Contract Details"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"title3"}
                    data-plasmic-override={overrides.title3}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title3
                    )}
                  >
                    {"Client"}
                  </div>
                  <div
                    data-plasmic-name={"selectedClient"}
                    data-plasmic-override={overrides.selectedClient}
                    className={classNames(projectcss.all, sty.selectedClient)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__aLv9Y)}
                    >
                      {renderPlasmicSlot({
                        defaultContents: (
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___08Cx
                            )}
                          >
                            <React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span"
                                }
                                style={{ fontWeight: 700 }}
                              >
                                {"Company"}
                              </span>
                            </React.Fragment>
                          </div>
                        ),

                        value: args.companySelected,
                        className: classNames(sty.slotTargetCompanySelected)
                      })}
                      <div
                        data-plasmic-name={"emailSelected"}
                        data-plasmic-override={overrides.emailSelected}
                        className={classNames(
                          projectcss.all,
                          sty.emailSelected
                        )}
                      >
                        {renderPlasmicSlot({
                          defaultContents: "email address",
                          value: args.emailSelected,
                          className: classNames(sty.slotTargetEmailSelected)
                        })}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"deleteSelection"}
                      data-plasmic-override={overrides.deleteSelection}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.deleteSelection
                      )}
                    >
                      {"X"}
                    </div>
                  </div>
                  <SearchRectangle
                    data-plasmic-name={"searchRectangle"}
                    data-plasmic-override={overrides.searchRectangle}
                    className={classNames(
                      "__wab_instance",
                      sty.searchRectangle
                    )}
                  />

                  <MenuSelectStack
                    data-plasmic-name={"menuSelectStack"}
                    data-plasmic-override={overrides.menuSelectStack}
                    className={classNames(
                      "__wab_instance",
                      sty.menuSelectStack
                    )}
                  />

                  <div
                    data-plasmic-name={"title2"}
                    data-plasmic-override={overrides.title2}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title2
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "small")
                      ? "Contract Title"
                      : "Contract Title"}
                  </div>
                  <div
                    data-plasmic-name={"rectangle9"}
                    data-plasmic-override={overrides.rectangle9}
                    className={classNames(projectcss.all, sty.rectangle9)}
                  >
                    <LoginInput
                      data-plasmic-name={"contractTitleInput"}
                      data-plasmic-override={overrides.contractTitleInput}
                      className={classNames(
                        "__wab_instance",
                        sty.contractTitleInput
                      )}
                    />
                  </div>
                </Stack__>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__xoCiR)}>
                <div className={classNames(projectcss.all, sty.freeBox___8UUL)}>
                  <div
                    data-plasmic-name={"title10"}
                    data-plasmic-override={overrides.title10}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title10
                    )}
                  >
                    {"Milestones"}
                  </div>
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__kVHpb
                  )}
                >
                  {
                    "Let your client pay in installments as each step in the contract is completed."
                  }
                </div>
                <div
                  data-plasmic-name={"moreMilestonesStack"}
                  data-plasmic-override={overrides.moreMilestonesStack}
                  className={classNames(
                    projectcss.all,
                    sty.moreMilestonesStack
                  )}
                >
                  <MilestoneEntry
                    data-plasmic-name={"milestoneEntry"}
                    data-plasmic-override={overrides.milestoneEntry}
                    className={classNames("__wab_instance", sty.milestoneEntry)}
                    number={
                      hasVariant(globalVariants, "screen", "medium")
                        ? "1."
                        : "1."
                    }
                  />
                </div>
                <button
                  data-plasmic-name={"addMilestoneButton"}
                  data-plasmic-override={overrides.addMilestoneButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    projectcss.__wab_text,
                    sty.addMilestoneButton
                  )}
                  ref={ref => {
                    $refs["addMilestoneButton"] = ref;
                  }}
                >
                  {"+ Add Milestone"}
                </button>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__kixiN)}>
                <div className={classNames(projectcss.all, sty.freeBox__c5OvA)}>
                  <div
                    data-plasmic-name={"title11"}
                    data-plasmic-override={overrides.title11}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title11
                    )}
                  >
                    {"Contract Terms (optional)"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"title12"}
                  data-plasmic-override={overrides.title12}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title12
                  )}
                >
                  {
                    "Specify the terms of your contract and deliverables, while providing transparent proof-of-agreement in the event of a dispute arbitration. "
                  }
                </div>
                <div
                  className={classNames(projectcss.all, sty.freeBox___1PI6K)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__p3KuC)}
                  >
                    <div
                      data-plasmic-name={"title17"}
                      data-plasmic-override={overrides.title17}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title17
                      )}
                    >
                      {"Upload signed contract or agreement (recommended)"}
                    </div>
                    <div
                      data-plasmic-name={"uploadButton"}
                      data-plasmic-override={overrides.uploadButton}
                      className={classNames(projectcss.all, sty.uploadButton)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__lfujH
                        )}
                      >
                        {hasVariant(globalVariants, "screen", "medium")
                          ? "Upload"
                          : "Upload"}
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__lrtdb)}
                    >
                      {renderPlasmicSlot({
                        defaultContents: (
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__fw9W
                            )}
                          >
                            {"Enter some text"}
                          </div>
                        ),

                        value: args.contractUploadText,
                        className: classNames(sty.slotTargetContractUploadText)
                      })}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__h02Aj)}
                  >
                    <div
                      data-plasmic-name={"title5"}
                      data-plasmic-override={overrides.title5}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title5
                      )}
                    >
                      {"OR"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__uui2C)}
                  >
                    <div
                      data-plasmic-name={"title19"}
                      data-plasmic-override={overrides.title19}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title19
                      )}
                    >
                      {
                        "Provide a description of the service or product that you are delivering"
                      }
                    </div>
                    <div
                      data-plasmic-name={"rectangle26"}
                      data-plasmic-override={overrides.rectangle26}
                      className={classNames(projectcss.all, sty.rectangle26)}
                    >
                      <textarea
                        data-plasmic-name={"contractDescription"}
                        data-plasmic-override={overrides.contractDescription}
                        className={classNames(
                          projectcss.all,
                          projectcss.textarea,
                          sty.contractDescription
                        )}
                        placeholder={
                          hasVariant(globalVariants, "screen", "medium")
                            ? ""
                            : undefined
                        }
                        ref={ref => {
                          $refs["contractDescription"] = ref;
                        }}
                        value={""}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__kXfco)}>
                <AdvancedOptionsComponent
                  data-plasmic-name={"advancedOptionsInstance"}
                  data-plasmic-override={overrides.advancedOptionsInstance}
                  className={classNames(
                    "__wab_instance",
                    sty.advancedOptionsInstance
                  )}
                />

                <div
                  data-plasmic-name={"advancedOptionsStack"}
                  data-plasmic-override={overrides.advancedOptionsStack}
                  className={classNames(
                    projectcss.all,
                    sty.advancedOptionsStack
                  )}
                >
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__u6GfZ)}
                  >
                    <div
                      data-plasmic-name={"title26"}
                      data-plasmic-override={overrides.title26}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title26
                      )}
                    >
                      {"Payment Methods"}
                    </div>
                    <Switch
                      data-plasmic-name={"achSwitch"}
                      data-plasmic-override={overrides.achSwitch}
                      className={classNames("__wab_instance", sty.achSwitch)}
                      isChecked={
                        generateStateValueProp($state, [
                          "achSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={async (...eventArgs) => {
                        ((...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "achSwitch",
                            "isChecked"
                          ])(eventArgs[0]);
                        }).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__lpOuP
                        )}
                      >
                        {"ACH"}
                      </div>
                    </Switch>
                    <Switch
                      data-plasmic-name={"cardSwitch"}
                      data-plasmic-override={overrides.cardSwitch}
                      className={classNames("__wab_instance", sty.cardSwitch)}
                      isChecked={
                        generateStateValueProp($state, [
                          "cardSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={async (...eventArgs) => {
                        ((...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "cardSwitch",
                            "isChecked"
                          ])(eventArgs[0]);
                        }).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__eLmX6
                        )}
                      >
                        {"Card"}
                      </div>
                    </Switch>
                    <Switch
                      data-plasmic-name={"cardSurchargeSwitch"}
                      data-plasmic-override={overrides.cardSurchargeSwitch}
                      className={classNames(
                        "__wab_instance",
                        sty.cardSurchargeSwitch
                      )}
                      isChecked={
                        generateStateValueProp($state, [
                          "cardSurchargeSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={async (...eventArgs) => {
                        ((...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "cardSurchargeSwitch",
                            "isChecked"
                          ])(eventArgs[0]);
                        }).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__wg7Tv
                        )}
                      >
                        {"Card (pass fee to client)"}
                      </div>
                    </Switch>
                  </Stack__>
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__uopRy)}
                  >
                    <div
                      data-plasmic-name={"title27"}
                      data-plasmic-override={overrides.title27}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title27
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "medium")
                        ? "Payment Reminders"
                        : "Payment Reminders"}
                    </div>
                    <Switch
                      data-plasmic-name={"paymentReminderSwitch"}
                      data-plasmic-override={overrides.paymentReminderSwitch}
                      className={classNames(
                        "__wab_instance",
                        sty.paymentReminderSwitch
                      )}
                      isChecked={
                        generateStateValueProp($state, [
                          "paymentReminderSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={async (...eventArgs) => {
                        ((...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "paymentReminderSwitch",
                            "isChecked"
                          ])(eventArgs[0]);
                        }).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__vkQxe
                        )}
                      >
                        {"Payment Reminder Notifications"}
                      </div>
                    </Switch>
                    <div
                      data-plasmic-name={"paymentReminderStack"}
                      data-plasmic-override={overrides.paymentReminderStack}
                      className={classNames(
                        projectcss.all,
                        sty.paymentReminderStack
                      )}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___1XEBy
                        )}
                      >
                        {"Every:"}
                      </div>
                      <input
                        data-plasmic-name={"reminderNumber"}
                        data-plasmic-override={overrides.reminderNumber}
                        className={classNames(
                          projectcss.all,
                          projectcss.input,
                          sty.reminderNumber
                        )}
                        placeholder={"0"}
                        ref={ref => {
                          $refs["reminderNumber"] = ref;
                        }}
                        size={1}
                        type={"number"}
                        value={""}
                      />

                      <AutomationSelect
                        data-plasmic-name={"paymentReminderSelect"}
                        data-plasmic-override={overrides.paymentReminderSelect}
                        className={classNames(
                          "__wab_instance",
                          sty.paymentReminderSelect
                        )}
                        onChange={async (...eventArgs) => {
                          ((...eventArgs) => {
                            generateStateOnChangeProp($state, [
                              "paymentReminderSelect",
                              "value"
                            ])(eventArgs[0]);
                          }).apply(null, eventArgs);
                          if (
                            eventArgs.length > 1 &&
                            eventArgs[1] &&
                            eventArgs[1]._plasmic_state_init_
                          ) {
                            return;
                          }
                        }}
                        placeholder={"Select"}
                        value={generateStateValueProp($state, [
                          "paymentReminderSelect",
                          "value"
                        ])}
                      />
                    </div>
                    <div
                      data-plasmic-name={"paymentReminderStack2"}
                      data-plasmic-override={overrides.paymentReminderStack2}
                      className={classNames(
                        projectcss.all,
                        sty.paymentReminderStack2
                      )}
                    >
                      <div
                        data-plasmic-name={"title29"}
                        data-plasmic-override={overrides.title29}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.title29
                        )}
                      >
                        {"(after the date each payment request is sent on)"}
                      </div>
                    </div>
                  </Stack__>
                </div>
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {"Please enter all of the required fields"}
              </div>
              <div
                data-plasmic-name={"sendButton"}
                data-plasmic-override={overrides.sendButton}
                className={classNames(projectcss.all, sty.sendButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__mg8Wv
                  )}
                >
                  {hasVariant(globalVariants, "screen", "medium")
                    ? "Review and Send"
                    : "Review and Send"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "sheet2",
    "figmaPaste",
    "title4",
    "title3",
    "selectedClient",
    "emailSelected",
    "deleteSelection",
    "searchRectangle",
    "menuSelectStack",
    "title2",
    "rectangle9",
    "contractTitleInput",
    "title10",
    "moreMilestonesStack",
    "milestoneEntry",
    "addMilestoneButton",
    "title11",
    "title12",
    "title17",
    "uploadButton",
    "title5",
    "title19",
    "rectangle26",
    "contractDescription",
    "advancedOptionsInstance",
    "advancedOptionsStack",
    "title26",
    "achSwitch",
    "cardSwitch",
    "cardSurchargeSwitch",
    "title27",
    "paymentReminderSwitch",
    "paymentReminderStack",
    "reminderNumber",
    "paymentReminderSelect",
    "paymentReminderStack2",
    "title29",
    "errorText",
    "sendButton"
  ],

  sidebar: ["sidebar"],
  sheet2: [
    "sheet2",
    "figmaPaste",
    "title4",
    "title3",
    "selectedClient",
    "emailSelected",
    "deleteSelection",
    "searchRectangle",
    "menuSelectStack",
    "title2",
    "rectangle9",
    "contractTitleInput"
  ],

  figmaPaste: [
    "figmaPaste",
    "title4",
    "title3",
    "selectedClient",
    "emailSelected",
    "deleteSelection",
    "searchRectangle",
    "menuSelectStack",
    "title2",
    "rectangle9",
    "contractTitleInput"
  ],

  title4: ["title4"],
  title3: ["title3"],
  selectedClient: ["selectedClient", "emailSelected", "deleteSelection"],
  emailSelected: ["emailSelected"],
  deleteSelection: ["deleteSelection"],
  searchRectangle: ["searchRectangle"],
  menuSelectStack: ["menuSelectStack"],
  title2: ["title2"],
  rectangle9: ["rectangle9", "contractTitleInput"],
  contractTitleInput: ["contractTitleInput"],
  title10: ["title10"],
  moreMilestonesStack: ["moreMilestonesStack", "milestoneEntry"],
  milestoneEntry: ["milestoneEntry"],
  addMilestoneButton: ["addMilestoneButton"],
  title11: ["title11"],
  title12: ["title12"],
  title17: ["title17"],
  uploadButton: ["uploadButton"],
  title5: ["title5"],
  title19: ["title19"],
  rectangle26: ["rectangle26", "contractDescription"],
  contractDescription: ["contractDescription"],
  advancedOptionsInstance: ["advancedOptionsInstance"],
  advancedOptionsStack: [
    "advancedOptionsStack",
    "title26",
    "achSwitch",
    "cardSwitch",
    "cardSurchargeSwitch",
    "title27",
    "paymentReminderSwitch",
    "paymentReminderStack",
    "reminderNumber",
    "paymentReminderSelect",
    "paymentReminderStack2",
    "title29"
  ],

  title26: ["title26"],
  achSwitch: ["achSwitch"],
  cardSwitch: ["cardSwitch"],
  cardSurchargeSwitch: ["cardSurchargeSwitch"],
  title27: ["title27"],
  paymentReminderSwitch: ["paymentReminderSwitch"],
  paymentReminderStack: [
    "paymentReminderStack",
    "reminderNumber",
    "paymentReminderSelect"
  ],

  reminderNumber: ["reminderNumber"],
  paymentReminderSelect: ["paymentReminderSelect"],
  paymentReminderStack2: ["paymentReminderStack2", "title29"],
  title29: ["title29"],
  errorText: ["errorText"],
  sendButton: ["sendButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEscrowSubmission__ArgProps,
          internalVariantPropNames: PlasmicEscrowSubmission__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEscrowSubmission__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicEscrowSubmission";
  } else {
    func.displayName = `PlasmicEscrowSubmission.${nodeName}`;
  }
  return func;
}

export const PlasmicEscrowSubmission = Object.assign(
  // Top-level PlasmicEscrowSubmission renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    sheet2: makeNodeComponent("sheet2"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    title4: makeNodeComponent("title4"),
    title3: makeNodeComponent("title3"),
    selectedClient: makeNodeComponent("selectedClient"),
    emailSelected: makeNodeComponent("emailSelected"),
    deleteSelection: makeNodeComponent("deleteSelection"),
    searchRectangle: makeNodeComponent("searchRectangle"),
    menuSelectStack: makeNodeComponent("menuSelectStack"),
    title2: makeNodeComponent("title2"),
    rectangle9: makeNodeComponent("rectangle9"),
    contractTitleInput: makeNodeComponent("contractTitleInput"),
    title10: makeNodeComponent("title10"),
    moreMilestonesStack: makeNodeComponent("moreMilestonesStack"),
    milestoneEntry: makeNodeComponent("milestoneEntry"),
    addMilestoneButton: makeNodeComponent("addMilestoneButton"),
    title11: makeNodeComponent("title11"),
    title12: makeNodeComponent("title12"),
    title17: makeNodeComponent("title17"),
    uploadButton: makeNodeComponent("uploadButton"),
    title5: makeNodeComponent("title5"),
    title19: makeNodeComponent("title19"),
    rectangle26: makeNodeComponent("rectangle26"),
    contractDescription: makeNodeComponent("contractDescription"),
    advancedOptionsInstance: makeNodeComponent("advancedOptionsInstance"),
    advancedOptionsStack: makeNodeComponent("advancedOptionsStack"),
    title26: makeNodeComponent("title26"),
    achSwitch: makeNodeComponent("achSwitch"),
    cardSwitch: makeNodeComponent("cardSwitch"),
    cardSurchargeSwitch: makeNodeComponent("cardSurchargeSwitch"),
    title27: makeNodeComponent("title27"),
    paymentReminderSwitch: makeNodeComponent("paymentReminderSwitch"),
    paymentReminderStack: makeNodeComponent("paymentReminderStack"),
    reminderNumber: makeNodeComponent("reminderNumber"),
    paymentReminderSelect: makeNodeComponent("paymentReminderSelect"),
    paymentReminderStack2: makeNodeComponent("paymentReminderStack2"),
    title29: makeNodeComponent("title29"),
    errorText: makeNodeComponent("errorText"),
    sendButton: makeNodeComponent("sendButton"),
    // Metadata about props expected for PlasmicEscrowSubmission
    internalVariantProps: PlasmicEscrowSubmission__VariantProps,
    internalArgProps: PlasmicEscrowSubmission__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicEscrowSubmission;
/* prettier-ignore-end */
